var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCEstrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 53 50.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-500{fill:url(#Degradado_sin_nombre_14);}.cls-501{fill:#ffdb53;}.cls-502{fill:#fcbd11;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 12.91,
    y1: 10.87,
    x2: 32.07,
    y2: 35.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffda4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ffd42b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ffcf14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ffcd06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ffcc01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fec805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fcbd11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcbd11"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-500",
    d: "M27.3.5l7.5,15.2a.7.7,0,0,0,.6.5l16.9,2.4a.9.9,0,0,1,.5,1.5L40.6,32a1.1,1.1,0,0,0-.3.7l2.9,16.8a.8.8,0,0,1-1.2.9L26.9,42.5a1.1,1.1,0,0,0-.8,0L11,50.4a.8.8,0,0,1-1.2-.9l2.9-16.8a1.1,1.1,0,0,0-.3-.7L.3,20.1a.9.9,0,0,1,.4-1.5l16.9-2.4a.7.7,0,0,0,.6-.5L25.7.5A.9.9,0,0,1,27.3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M26.5,4,19.8,17A2.3,2.3,0,0,1,18,18.2L3.4,19.5l15.4.8A2.3,2.3,0,0,0,21,18.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-502",
    d: "M10.1,47.6l-.3,1.9a.8.8,0,0,0,1.2.9l15.1-7.9a1.1,1.1,0,0,1,.8,0L42,50.4a.8.8,0,0,0,1.2-.9L40.3,32.7a1.1,1.1,0,0,1,.3-.7L52.8,20.1a.9.9,0,0,0-.5-1.5l-5.7-.8C37.5,34.2,23.5,42.8,10.1,47.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCEstrella);
export default __webpack_public_path__ + "static/media/c-estrella.5dedd798.svg";
export { ForwardRef as ReactComponent };